import { FORM_MODES } from 'modules/campaigns/config';
import { cleanCreativesEditingResources } from 'modules/campaigns/modules/creative-editor/flows';
import { generateLibraryCreativeEditorPath } from '../utils/generateLibraryCreativeEditorPath';

export const editLibraryCreative = ({ data, context }) => {
    const { id: creativeId, accountName: accountId } = data;
    const { navigate, dispatch } = context;

    const editLibraryCreativePath = generateLibraryCreativeEditorPath({
        mode: FORM_MODES.EDIT,
        accountId,
        creativeId,
    });

    dispatch(cleanCreativesEditingResources());

    navigate(editLibraryCreativePath);
};
